
<template>
  <div class="dashboard-wrap">
    <!-- 搜索条件 -->
    <el-row>
      <el-col :sm="24" :lg="24">
        <el-card shadow="hover" class="pie-wrap">
          <div style="margin-bottom:30px;">
            <el-row>
              <el-col
                style="text-align:center;"
                v-for="(ele, index) in province"
                :sm="2"
                :lg="2"
                :key="index"
              >
                <!-- <router-link 
                  :key="ele.proviceCode"
                  :to="{path:ele.proviceCode?'/cityDetail':'dashboard',query:{param:ele.proviceCode}}">
                 
                </router-link>-->
                <el-button
                  @click="handleProvinceClick(ele,index)"
                  :type="indexClick== index ?'primary':'text'"
                >{{ele.provinceName}}</el-button>
              </el-col>
              <el-button v-show="province.length>=8" class="el-col-lg-2" @click="handleLookMore" type="text">{{more?'更多':'收起'}}</el-button>
            </el-row>
            <el-row class="block">
              <el-col :span="12">
                <div>
                  <span>统计时间 : </span>
                  <el-date-picker
                    :clearable="false"
                    size="mini"
                    v-model="date"
                    value-format="timestamp"
                    type="daterange"
                    placeholder="选择日期范围"
                  ></el-date-picker>
                </div>
              </el-col>
              <el-col :span="2">
                <el-button @click="handleSezarch" size="mini" type="primary">查询</el-button>
              </el-col>
              <el-col :span="2">
                <el-button v-show="hideExport" @click="exportExcel" size="mini" type="primary">导出</el-button>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row>
    <div v-if="provinceCode==''">
        <all-detail :date='date' ref="search"></all-detail>
    </div>
    <div v-else>
        <pro-detail :areano='provinceCode' :date='date' ref="search"></pro-detail>
    </div>
    
    <!-- 提示框 -->
    <!-- <span v-show="title" class="title">
      <img src="../../assets/images/title.png">
      以下标红卡数是以消费省统计在一定时间内有过异常消费行为的卡数之和（注：存在同一张卡有多种异常消费行为的情况）
      <img
        @click="removeTitle"
        src="../../assets/images/delete.png"
      >
    </span> -->
    <!-- 合计 -->
    <!-- <el-row>
      <el-col :sm="24" :lg="24">
        <el-row>
          <el-col :sm="24" :lg="24">
            <el-card shadow="hover" class="pie-wrap">
              <div slot="header" class="pie-header">
                <span class>合计</span>
              </div>
              <div>
                <el-row>
                  <el-col :sm="11" :lg="11">
                    <div
                      style="width:111%;height:3px;background-color:#41b883;margin-top:-22px;margin-left:-15px;border-radius:10px 10px 0 0 "
                    ></div>
                    <el-row style="margin-top:20px">
                      <el-col :sm="12" :lg="12">
                        <ul class="left">
                          <li class="left_head">异常主卡</li>
                        </ul>
                      </el-col>
                      <el-col :sm="12" :lg="12">
                        <ul class="right">
                          <li class="right_head" v-if="total&&total.masterCard">{{total.masterCard}}</li>
                        </ul>
                      </el-col>
                    </el-row>
                    <el-row class="topic">
                      <el-col :sm="6" :lg="6">油品异常</el-col>
                      <el-col :sm="6" :lg="6">加油次数异常</el-col>
                      <el-col :sm="6" :lg="6">加油量异常</el-col>
                      <el-col :sm="6" :lg="6">位置异常</el-col>
                    </el-row>
                    <el-row class="content" v-if="total">
                      <el-col :sm="6" :lg="6">{{total.oliMasterCard}}</el-col>
                      <el-col :sm="6" :lg="6">{{total.fuelMasterCard}}</el-col>
                      <el-col :sm="6" :lg="6">{{total.litterMasterCard}}</el-col>
                      <el-col :sm="6" :lg="6">{{total.positionMasterCard}}</el-col>
                    </el-row>
                  </el-col>
                  <el-col :offset="2" :sm="11" :lg="11">
                    <div
                      style="width:111%;height:3px;background-color:orange;margin-top:-22px;margin-left:-15px;border-radius:10px 10px 0 0"
                    ></div>
                    <el-row style="margin-top:20px">
                      <el-col :sm="12" :lg="12">
                        <ul class="left">
                          <li class="left_head">异常副卡</li>
                        </ul>
                      </el-col>
                      <el-col :sm="12" :lg="12" v-if="total">
                        <ul class="right">
                          <li class="right_head">{{total.salveCard}}</li>
                        </ul>
                      </el-col>
                    </el-row>
                    <el-row class="topic">
                      <el-col :sm="6" :lg="6">油品异常</el-col>
                      <el-col :sm="6" :lg="6">加油次数异常</el-col>
                      <el-col :sm="6" :lg="6">加油量异常</el-col>
                      <el-col :sm="6" :lg="6">位置异常</el-col>
                    </el-row>
                    <el-row class="content" v-if="total">
                      <el-col :sm="6" :lg="6">{{total.olisalveCard}}</el-col>
                      <el-col :sm="6" :lg="6">{{total.fuelSalveCard}}</el-col>
                      <el-col :sm="6" :lg="6">{{total.litterSalverCard}}</el-col>
                      <el-col :sm="6" :lg="6">{{total.positionSalveCard}}</el-col>
                    </el-row>
                  </el-col>
                </el-row>
              </div>
            </el-card>
          </el-col>
        </el-row>
      </el-col>
    </el-row> -->
    <!-- 表单 -->
    <!-- <el-row :gutter="20" v-if="tags.length>0">
      <el-col v-for="(ele, index) in tags" :sm="12" :lg="12" :key="index">
        <el-card shadow="hover" class="pie-wrap">
          <div slot="header" class="pie-header">
            <span class>{{ele.areaName}}:</span>
            <router-link
              :key="ele.areano"
              :to="{path:'/locationDetail',query:{areano:ele.areano,areaName:ele.areaName,seletctDate:date}}"
            >
              <el-button @click="handleLookDetailClick" size="mini" class="detail">查看详情</el-button>
            </router-link>
          </div>
          <div>
            <el-row>
              <el-col :sm="11" :lg="11">
                <div
                  style="width:111%;height:3px;background-color:#41b883;margin-top:-22px;margin-left:-15px;border-radius:10px 10px 0 0 "
                ></div>
                <el-col :sm="12" :lg="12">
                  <ul class="left">
                    <li class="left_head">异常主卡</li>
                    <li>油品异常</li>
                    <li>加油次数异常</li>
                    <li>加油量异常</li>
                    <li>位置异常</li>
                  </ul>
                </el-col>
                <el-col :sm="12" :lg="12" v-if="ele">
                  <ul class="right">
                    <li class="right_head" v-if="ele&&ele.allAbnormalMain">{{ele.allAbnormalMain}}</li>
                    <li>{{ele.oilAbnormalMain}}</li>
                    <li>{{ele.countAbnormalMain }}</li>
                    <li>{{ele.litterAbnormalMain}}</li>
                    <li>{{ele.routeAbnormalMain }}</li>
                  </ul>
                </el-col>
              </el-col>
              <el-col :offset="2" :sm="11" :lg="11">
                <div
                  style="width:111%;height:3px;background-color:orange;margin-top:-22px;margin-left:-15px;border-radius:10px 10px 0 0"
                ></div>
                <el-col :sm="12" :lg="12">
                  <ul class="left">
                    <li class="left_head">异常副卡</li>
                    <li>油品异常</li>
                    <li>加油次数异常</li>
                    <li>加油量异常</li>
                    <li>位置异常</li>
                  </ul>
                </el-col>
                <el-col :sm="12" :lg="12" v-if="ele">
                  <ul class="right">
                    <li class="right_head">{{ele.allAbnormalVice }}</li>
                    <li>{{ele.oilAbnormalVice}}</li>
                    <li>{{ele.countAbnormalVice}}</li>
                    <li>{{ele.litterAbnormalVice}}</li>
                    <li>{{ele.routeAbnormalVice}}</li>
                  </ul>
                </el-col>
              </el-col>
            </el-row>
          </div>
        </el-card>
      </el-col>
    </el-row> -->
  </div>
</template>

<script>
import allDetail from './allDetail.vue'
import proDetail from './provinceDetail.vue'
import Cookies from 'js-cookie'
import { randomIntegerInRange,hideExport } from '@/utils/tools'
import http from '@/api/allRequest'
import storage from '@/utils/storage'
// import { getAllCity, getProvinceData } from '@/api/dashboard'

export default {
  name: 'dashboard',
  components: {
    allDetail,
    proDetail
  },
  data() {
    return {
      hideExport:hideExport,
      date: [new Date(new Date() * 1 - 30 * 24 * 3600 * 1000) * 1,
        new Date(new Date() * 1 - 1 * 24 * 3600 * 1000) * 1],
      province: [],
      provinceCode: '',
      tags: [],
      more: false,
      indexClick:0,
      areano: '',
      total: {}, //合计数据
      title: Cookies.get(`title${Cookies.get('user')}`) ? false : true //提示框是否显示
    }
  },
  watch: {},
  mounted() {
    this.getAllCitys()
    // this.getProvinceData()
    // this.getAllData() // 获取合计数据
  },
  beforeDestroy() {},
  methods: {
    removeTitle() {
      let that = this
      that.title = false
      Cookies.set(`title${Cookies.get('user')}`, 'true')
    },
    handleLookDetailClick() {
      window.sessionStorage.setItem('date', this.date)
    },
    //省份的点击事件
    handleProvinceClick(province,i) {
      this.indexClick = i
      this.provinceCode = province.provinceCode||''
      const na_me = province.provinceName
      this.$store.dispatch('setProvinceName', { na_me })
      // // path:ele.proviceCode?'/cityDetail':'dashboard',query:{param:ele.proviceCode}}
      // if (province.provinceCode) {
      //   this.$router.push({
      //     path: '/cityDetail',
      //     query: { param: province.provinceCode }
      //   })
      // } else {
      //   this.$router.push({ path: 'dashboard' })
      // }
    },
    //省份表格数据
    getProvinceData() {
      return new Promise(async (resolve, reject) => {
        try {
          let areano = this.areano
          let syncTimeStart = new Date().getTime() - 2592000000
          let syncTimeEnd = new Date().getTime()
          const response = await this.$store.dispatch('getProvincesData', {
            areano,
            syncTimeStart,
            syncTimeEnd
          })
          if (response.code == 200 && response.data.abnormalList) {
            this.tags = response.data.abnormalList || ''
          }
          resolve()
        } catch (err) {
          reject(err)
        }
      })
    },
    //查询
    handleSezarch() {
      this.$refs.search.handleSezarch()
      // this.getAllData() // 2019.5.5 程梦雅 修复点击查询合计数据无变化
      // return new Promise(async (resolve, reject) => {
      //   try {
      //     let areano = this.areano
      //     let syncTimeStart = this.date ? new Date(this.date[0]).getTime() : ''
      //     let syncTimeEnd = this.date ? new Date(this.date[1]).getTime() : ''
      //     const response = await this.$store.dispatch('getProvincesData', {
      //       areano,
      //       syncTimeStart,
      //       syncTimeEnd
      //     })
      //     if (response.code == 200) {
      //       this.tags = response.data.abnormalList || ''
      //     }
      //     resolve()
      //   } catch (err) {
      //     reject(err)
      //   }
      // })
    },
    handleLookMore() {
      if(this.more){
        this.province = this.mainProvince.areaList
      }else{
        let listp = [].concat(this.mainProvince.areaList)
        this.province = listp.slice(0, 8)
      }
      this.more = !this.more
    },
    handleClick(row) {},
    getAllCitys() {
      return new Promise(async (resolve, reject) => {
        try {
          const response = await this.$store.dispatch('getAllCityData', {})
         
          if (response.code == 200) {
             Cookies.set('userType', response.data.userType);
             if(response.data.userType==2){
               storage.set('areaList',response.data.areaList);
             }
            //当返回的省份只有一个时  跳转
            if (response.data.areaList.length == 1) {
              this.provinceCode = response.data.areaList[0].provinceCode
             
              // this.$router.push({
              //   path:
              //     '/cityDetail?areano=' + response.data.areaList[0].provinceCode
              // })
            }else{
              response.data.areaList.unshift({
                provinceName: '全部',
                provinceCode: '',
                selected: false
              })
            }
               this.mainProvince = response.data
            if (response.data.areaList.length > 8) {
              this.more = true //更多按钮显示
              this.province = response.data.areaList.slice(0, 8)
            } else {
              this.province = response.data.areaList
            }
          }
          resolve()
        } catch (err) {
          reject(err)
        }
      })
    },
    getAllData() {
      let that = this
      http.getAbnormalData({
          timeSection: this.date
        })
        .then(e => {
          if (e.code == 200) {
            that.total = { ...e.data }
          }
        })
    },
    exportExcel() {
      let areano = this.provinceCode
      let syncTimeStart = this.date ? new Date(this.date[0]).getTime() : ''
      let syncTimeEnd = this.date ? new Date(this.date[1]).getTime() : ''
     
      window.location.href =
        '/bi-api/abnormal/exportArea?areano=' +
        areano +
        '&syncTimeStart=' +
        syncTimeStart +
        '&syncTimeEnd=' +
        syncTimeEnd 
    },
  }
}
</script>
<style lang="stylus" scoped>
span.title {
  background: #fefeed;
  display: inline-block;
  margin-top: 15px;
  padding: 5px 12px;
  line-height: 1.5;
  font-size: 12px;
  width: calc(100% - 24px) !important;
  border-radius: 5px;
}

span.title img {
  vertical-align: middle;
}

span.title img:nth-child(1) {
  margin-top: -3px;
  display: inline-block;
  margin-right: 5px;
}

span.title img:nth-of-type(2) {
  margin-top: 3px;
  display: inline-block;
  margin-right: 5px;
  float: right;
}

.el-button--primary {
  color: #fff;
  background-color: #4E8ED6;
  border-color: #4E8ED6;
}

.el-button--text {
  color: #4E8ED6;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

box-style(bg) {
  width: 100%;
  height: 130px;
  background: white;
  display: flex;
  margin-top: 15px;

  .leftPart {
    background: bg;
    width: 130px;
    @extend .flex-center;
  }

  .rightPart {
    flex: 1;
    color: #99a9c0;
    @extend .flex-center;
    flex-direction: column;

    .number {
      font-size: 30px;
      padding-bottom: 6px;
    }

    .font-center {
      text-align: center;
    }
  }
}

.dashboard-row {
  width: 100%;
  height: 400px;
  margin-top: 15px;
  background: white;
}

.dashboard-wrap {
  margin-top: -15px;

  .box1 {
    box-style(#41b883);
  }

  .box2 {
    box-style(#9ab7e0);
  }

  .box3 {
    box-style(#f7c94d);
  }

  .box4 {
    box-style(#e45f5f);
  }

  .block {
    margin-top: 20px;

    .pagination {
      text-align: center;
    }
  }

  .line-chart {
    @extend .dashboard-row;
    padding: 15px;
    box-sizing: border-box;
  }

  .todo-wrap {
    @extend .dashboard-row;

    .todo-header {
      span {
        font-weight: bold;
        color: #6fb998;
      }

      .enterTodo {
        float: right;
        width: 140px;
        position: relative;
        top: -8px;
        right: -11px;
      }
    }

    .todo-list {
      div:not(:first-child) {
        margin-top: 15px;
      }
    }
  }

  .system-report {
    @extend .dashboard-row;
    height: 520px;

    .report-header {
      span {
        font-weight: bold;
        color: #6fb998;
      }
    }

    .report-content {
      .el-alert:not(:first-child) {
        margin-top: 15px;
      }

      .progress-wrap {
        margin-top: 20px;
        text-align: center;
        padding: 20px;

        .el-progress:not(:first-child) {
          margin-left: 20px;
        }
      }
    }
  }

  .pie-wrap {
    @extend .dashboard-row;
    height: 100%;

    .topic {
      font-size: 14px;
      height: 25px;
      color: #aaa;
      margin-top: 10px;
      text-align: center;
    }

    .content {
      margin-top: 10px;
      font-size: 14px;
      height: 25px;
      text-align: center;
    }

    .pie-header {
      position: relative;

      span {
        font-weight: bold;
        color: #6fb998;
      }

      .detail {
        position: absolute;
        right: 30px;
      }
    }

    .left {
      font-size: 14px;

      li {
        height: 25px;
        color: #aaa;
      }

      .left_head {
        font-size: 18px;
        color: black;
      }
    }

    .right {
      font-size: 14px;
      text-align: right;

      li {
        height: 25px;
      }

      .right_head {
        font-size: 18px;
        color: red;
      }
    }
  }
}
</style>
<style lang="stylus" scoped>
span.title {
  background: #fefeed;
  display: inline-block;
  margin-top: 15px;
  padding: 5px 12px;
  line-height: 1.5;
  font-size: 12px;
  width: 100%;
  border-radius: 5px;
}

span.title img {
  vertical-align: middle;
}

span.title img:nth-child(1) {
  margin-top: -3px;
  display: inline-block;
  margin-right: 5px;
}

span.title img:nth-of-type(2) {
  margin-top: 3px;
  display: inline-block;
  margin-right: 5px;
  float: right;
}

.el-button--primary {
  color: #fff;
  background-color: #4E8ED6;
  border-color: #4E8ED6;
}

.el-button--text {
  color: #4E8ED6;
}

.flex-center {
  display: flex;
  justify-content: center;
  align-items: center;
}

box-style(bg) {
  width: 100%;
  height: 130px;
  background: white;
  display: flex;
  margin-top: 15px;

  .leftPart {
    background: bg;
    width: 130px;
    @extend .flex-center;
  }

  .rightPart {
    flex: 1;
    color: #99a9c0;
    @extend .flex-center;
    flex-direction: column;

    .number {
      font-size: 30px;
      padding-bottom: 6px;
    }

    .font-center {
      text-align: center;
    }
  }
}

.dashboard-row {
  width: 100%;
  height: 400px;
  margin-top: 15px;
  background: white;
}

.dashboard-wrap {
  margin-top: -15px;

  .box1 {
    box-style(#41b883);
  }

  .box2 {
    box-style(#9ab7e0);
  }

  .box3 {
    box-style(#f7c94d);
  }

  .box4 {
    box-style(#e45f5f);
  }

  .block {
    margin-top: 20px;

    .pagination {
      text-align: center;
    }
  }

  .line-chart {
    @extend .dashboard-row;
    padding: 15px;
    box-sizing: border-box;
  }

  .todo-wrap {
    @extend .dashboard-row;

    .todo-header {
      span {
        font-weight: bold;
        color: #6fb998;
      }

      .enterTodo {
        float: right;
        width: 140px;
        position: relative;
        top: -8px;
        right: -11px;
      }
    }

    .todo-list {
      div:not(:first-child) {
        margin-top: 15px;
      }
    }
  }

  .system-report {
    @extend .dashboard-row;
    height: 520px;

    .report-header {
      span {
        font-weight: bold;
        color: #6fb998;
      }
    }

    .report-content {
      .el-alert:not(:first-child) {
        margin-top: 15px;
      }

      .progress-wrap {
        margin-top: 20px;
        text-align: center;
        padding: 20px;

        .el-progress:not(:first-child) {
          margin-left: 20px;
        }
      }
    }
  }

  .pie-wrap {
    @extend .dashboard-row;
    height: 100%;

    .topic {
      font-size: 14px;
      height: 25px;
      color: #aaa;
      margin-top: 10px;
      text-align: center;
    }

    .content {
      margin-top: 10px;
      font-size: 14px;
      height: 25px;
      text-align: center;
    }

    .pie-header {
      position: relative;

      span {
        font-weight: bold;
        color: #6fb998;
      }

      .detail {
        position: absolute;
        right: 30px;
      }
    }

    .left {
      font-size: 14px;

      li {
        height: 25px;
        color: #aaa;
      }

      .left_head {
        font-size: 18px;
        color: black;
      }
    }

    .right {
      font-size: 14px;
      text-align: right;

      li {
        height: 25px;
      }

      .right_head {
        font-size: 18px;
        color: red;
      }
    }
  }
}
</style>
